<template>
  <tr class="tr">
    <slot />
  </tr>
</template>

<script setup lang="ts">
</script>

<style scoped>
@media (max-width: 600px) {
  tbody .tr {
    display: flex;
    flex-wrap: wrap;
    grid-template-columns: 1fr; /* Em telas pequenas, empilha os itens */
    min-width: 100%;
  }
}
</style>